var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArchitectureWide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 3000 1000"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "architecture_wide_svg__linear-gradient",
    x1: 423.61,
    y1: 739.02,
    x2: 157.82,
    y2: 278.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#abd2e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "architecture_wide_svg__linear-gradient-2",
    x1: 2724.76,
    y1: 112.32,
    x2: 2266.36,
    y2: 906.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b1cfde"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "architecture_wide_svg__linear-gradient-3",
    x1: 2687.2,
    y1: 177.37,
    x2: 2303.92,
    y2: 841.23,
    xlinkHref: "#architecture_wide_svg__linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "architecture_wide_svg__linear-gradient-4",
    x1: 2603.34,
    y1: 322.63,
    x2: 2387.78,
    y2: 695.98,
    xlinkHref: "#architecture_wide_svg__linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "architecture_wide_svg__linear-gradient-5",
    x1: 1522.33,
    y1: 429.19,
    x2: 1006.53,
    y2: 596.78,
    xlinkHref: "#architecture_wide_svg__linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "architecture_wide_svg__clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-1",
    d: "M364.23 448l-129.38.25a61.56 61.56 0 00-61.18 61.41 61.56 61.56 0 0061.42 61.18l129.38-.25a61.56 61.56 0 0061.18-61.41A61.56 61.56 0 00364.23 448z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "architecture_wide_svg__clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-1",
    d: "M2295.29 94.69h-151.42a21.63 21.63 0 00-21.92 21.89v273.65a21.63 21.63 0 0021.92 21.89h151.42c11.65 0 21.92-10.26 21.92-21.89V116.59a21.63 21.63 0 00-21.92-21.9z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "architecture_wide_svg__clip-path-3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "architecture_wide_svg__cls-1",
    cx: 1265.3,
    cy: 514.92,
    rx: 161.58,
    ry: 162.38
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "architecture_wide_svg__clip-path-4"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "architecture_wide_svg__cls-2",
    cx: 1265.87,
    cy: 514.34,
    rx: 161.58,
    ry: 162.38
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "architecture_wide_svg__clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-1",
    d: "M2627.77 853.23a12.34 12.34 0 0012.49-12.5V636.45c0-7-5.46-13.76-12.49-13.76H2323c-7 0-12.49 6.72-12.49 13.76v204.28a12.34 12.34 0 0012.49 12.5z"
  })), /*#__PURE__*/React.createElement("style", null, ".architecture_wide_svg__cls-1,.architecture_wide_svg__cls-10,.architecture_wide_svg__cls-2{fill:none}.architecture_wide_svg__cls-13,.architecture_wide_svg__cls-2,.architecture_wide_svg__cls-42,.architecture_wide_svg__cls-43,.architecture_wide_svg__cls-44,.architecture_wide_svg__cls-45,.architecture_wide_svg__cls-46,.architecture_wide_svg__cls-47,.architecture_wide_svg__cls-48,.architecture_wide_svg__cls-49,.architecture_wide_svg__cls-50,.architecture_wide_svg__cls-51,.architecture_wide_svg__cls-52,.architecture_wide_svg__cls-53,.architecture_wide_svg__cls-54,.architecture_wide_svg__cls-55,.architecture_wide_svg__cls-56,.architecture_wide_svg__cls-57,.architecture_wide_svg__cls-58,.architecture_wide_svg__cls-59,.architecture_wide_svg__cls-60,.architecture_wide_svg__cls-61,.architecture_wide_svg__cls-62,.architecture_wide_svg__cls-63,.architecture_wide_svg__cls-64,.architecture_wide_svg__cls-65{stroke:#0e1932;stroke-linecap:round;stroke-linejoin:round}.architecture_wide_svg__cls-13,.architecture_wide_svg__cls-2{stroke-width:3.27px}.architecture_wide_svg__cls-21{opacity:.2}.architecture_wide_svg__cls-5{fill:#6bc6c4;opacity:.47}.architecture_wide_svg__cls-10{stroke:#a8c0dd;stroke-miterlimit:10;stroke-width:.72px}.architecture_wide_svg__cls-11{fill:#253a60;opacity:.7}.architecture_wide_svg__cls-12,.architecture_wide_svg__cls-13{fill:#fff}.architecture_wide_svg__cls-20,.architecture_wide_svg__cls-21,.architecture_wide_svg__cls-42,.architecture_wide_svg__cls-43,.architecture_wide_svg__cls-44,.architecture_wide_svg__cls-45,.architecture_wide_svg__cls-46,.architecture_wide_svg__cls-47,.architecture_wide_svg__cls-48,.architecture_wide_svg__cls-49,.architecture_wide_svg__cls-50,.architecture_wide_svg__cls-51,.architecture_wide_svg__cls-52,.architecture_wide_svg__cls-53,.architecture_wide_svg__cls-54,.architecture_wide_svg__cls-55,.architecture_wide_svg__cls-56,.architecture_wide_svg__cls-57,.architecture_wide_svg__cls-58,.architecture_wide_svg__cls-59,.architecture_wide_svg__cls-60,.architecture_wide_svg__cls-61,.architecture_wide_svg__cls-62,.architecture_wide_svg__cls-63,.architecture_wide_svg__cls-64,.architecture_wide_svg__cls-65{fill:#0e1932}.architecture_wide_svg__cls-42{stroke-width:.13px;opacity:.23}.architecture_wide_svg__cls-43{stroke-width:.26px;opacity:.26}.architecture_wide_svg__cls-44{stroke-width:.39px;opacity:.3}.architecture_wide_svg__cls-45{stroke-width:.52px;opacity:.33}.architecture_wide_svg__cls-46{stroke-width:.65px;opacity:.36}.architecture_wide_svg__cls-47{stroke-width:.78px;opacity:.39}.architecture_wide_svg__cls-48{stroke-width:.91px;opacity:.42}.architecture_wide_svg__cls-49{stroke-width:1.04px;opacity:.46}.architecture_wide_svg__cls-50{stroke-width:1.18px;opacity:.49}.architecture_wide_svg__cls-51{stroke-width:1.31px;opacity:.52}.architecture_wide_svg__cls-52{stroke-width:1.44px;opacity:.55}.architecture_wide_svg__cls-53{stroke-width:1.57px;opacity:.58}.architecture_wide_svg__cls-54{stroke-width:1.7px;opacity:.62}.architecture_wide_svg__cls-55{stroke-width:1.83px;opacity:.65}.architecture_wide_svg__cls-56{stroke-width:1.96px;opacity:.68}.architecture_wide_svg__cls-57{stroke-width:2.09px;opacity:.71}.architecture_wide_svg__cls-58{stroke-width:2.22px;opacity:.74}.architecture_wide_svg__cls-59{stroke-width:2.35px;opacity:.78}.architecture_wide_svg__cls-60{stroke-width:2.48px;opacity:.81}.architecture_wide_svg__cls-61{stroke-width:2.61px;opacity:.84}.architecture_wide_svg__cls-62{stroke-width:2.74px;opacity:.87}.architecture_wide_svg__cls-63{stroke-width:2.87px;opacity:.9}.architecture_wide_svg__cls-64{stroke-width:3px;opacity:.94}.architecture_wide_svg__cls-65{stroke-width:3.13px;opacity:.97}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "architecture_wide_svg__Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 290.72,
    cy: 508.84,
    rx: 265.72,
    ry: 265.76,
    fill: "url(#architecture_wide_svg__linear-gradient)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#architecture_wide_svg__clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-5",
    d: "M374.71 458.46l-129.38.25a61.56 61.56 0 00-61.18 61.41 61.56 61.56 0 0061.42 61.18l129.38-.25a61.56 61.56 0 0061.18-61.41 61.56 61.56 0 00-61.42-61.18z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2495.56,
    cy: 509.3,
    r: 458.32,
    fill: "url(#architecture_wide_svg__linear-gradient-2)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2495.56,
    cy: 509.3,
    r: 383.21,
    fill: "url(#architecture_wide_svg__linear-gradient-3)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2495.56,
    cy: 509.3,
    r: 215.52,
    fill: "url(#architecture_wide_svg__linear-gradient-4)",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("circle", {
    className: "architecture_wide_svg__cls-10",
    cx: 2496.53,
    cy: 512.06,
    r: 458.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "architecture_wide_svg__cls-10",
    cx: 2496.53,
    cy: 512.06,
    r: 383.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "architecture_wide_svg__cls-10",
    cx: 2496.53,
    cy: 512.06,
    r: 215.52
  }), /*#__PURE__*/React.createElement("circle", {
    className: "architecture_wide_svg__cls-11",
    cx: 2847.4,
    cy: 217.39,
    r: 11.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "architecture_wide_svg__cls-11",
    cx: 2880.32,
    cy: 544.92,
    r: 9.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "architecture_wide_svg__cls-11",
    cx: 2086.32,
    cy: 310.92,
    r: 8.85
  }), /*#__PURE__*/React.createElement("circle", {
    className: "architecture_wide_svg__cls-11",
    cx: 2284.32,
    cy: 520.92,
    r: 7.92
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-12",
    d: "M2143.94 766.25h166.94v-77.82h-166.94a19.19 19.19 0 00-19.44 19.45v38.92a19.19 19.19 0 0019.44 19.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-12",
    d: "M2628.77 623.69h-135v-21.26a19.19 19.19 0 00-19.44-19.43h-330.39a19.19 19.19 0 00-19.44 19.45v38.91a19.1 19.1 0 0019 19.45h166.94l1-.21v132.6l-.63-.35h-166.87a19.19 19.19 0 00-19.44 19.45v38.9a19.19 19.19 0 0019.44 19.45h306.78v32H2502v-48.38h-29 155.69a12.34 12.34 0 0012.49-12.5V637.45c.08-7.03-5.38-13.76-12.41-13.76zM2296.68 94.94h-151.42a21.63 21.63 0 00-21.92 21.89v273.64a21.63 21.63 0 0021.92 21.89h151.42c11.65 0 21.92-10.26 21.92-21.89V116.83a21.63 21.63 0 00-21.92-21.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-13",
    d: "M2295.29 94.69h-151.42a21.63 21.63 0 00-21.92 21.89v273.65a21.63 21.63 0 0021.92 21.89h151.42c11.65 0 21.92-10.26 21.92-21.89V116.59a21.63 21.63 0 00-21.92-21.9z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#architecture_wide_svg__clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-5",
    d: "M2306.69 104.59h-151.42a21.63 21.63 0 00-21.92 21.89v273.65a21.63 21.63 0 0021.92 21.87h151.42c11.65 0 21.92-10.26 21.92-21.89V126.49a21.63 21.63 0 00-21.92-21.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-2",
    d: "M2295.29 94.69h-151.42a21.63 21.63 0 00-21.92 21.89v273.65a21.63 21.63 0 0021.92 21.89h151.42c11.65 0 21.92-10.26 21.92-21.89V116.59a21.63 21.63 0 00-21.92-21.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-11",
    d: "M2240.48 122.56h-41.79a7.53 7.53 0 110-15.05h41.79A7.6 7.6 0 012248 115c-.67 4.82-3.41 7.56-7.52 7.56zM2219.8 380a7.57 7.57 0 01-7-7 9.21 9.21 0 011.76-4.83 6.92 6.92 0 019.68 0 6.41 6.41 0 010 9.67 5.42 5.42 0 01-4.44 2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-13",
    d: "M2373.77 338.13h132.42v52.8h-132.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-11",
    d: "M2388.18 350.18h103.6v28.69h-103.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-2",
    d: "M2386.81 338.17v-18.63m26.59 18.63v-18.63m26.58 18.63v-18.63m26.58 18.63v-18.63m26.58 18.63v-18.63m-106.33 89.98v-18.64m26.59 18.64v-18.64m26.58 18.64v-18.64m26.58 18.64v-18.64m26.58 18.64v-18.64m-52.8-141.09l.14 44.25m-17.57-22.6l17.28 24.61 16.86-24.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-13",
    d: "M2409.69 228.06l60.68-.12a28.87 28.87 0 0028.69-28.8 28.87 28.87 0 00-28.8-28.69l-60.68.12a28.87 28.87 0 00-28.69 28.8 28.87 28.87 0 0028.8 28.69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-11",
    d: "M2468.21 184.41a14.91 14.91 0 11-14.88 14.94 14.9 14.9 0 0114.88-14.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-13",
    d: "M2470.26 93.42l-60.68.12a28.87 28.87 0 00-28.69 28.8 28.87 28.87 0 0028.8 28.69l60.68-.12a28.87 28.87 0 0028.69-28.8 28.87 28.87 0 00-28.8-28.69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-11",
    d: "M2411.75 137.07a14.91 14.91 0 1114.88-14.94 14.9 14.9 0 01-14.88 14.94z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "architecture_wide_svg__cls-13",
    cx: 2577.4,
    cy: 271.91,
    rx: 68.25,
    ry: 68.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-2",
    d: "M2558.49 259.9l-13.68 11.6-5.8-17.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-2",
    d: "M2555.48 297.78a33.31 33.31 0 0024 10.22c18.72 0 33.9-15.63 33.9-34.9s-15.18-34.9-33.9-34.9c-16.6 0-30.41 12.28-33.33 28.5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1264.43,
    cy: 512.98,
    rx: 271.1,
    ry: 271.13,
    fill: "url(#architecture_wide_svg__linear-gradient-5)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "architecture_wide_svg__cls-12",
    cx: 1265.88,
    cy: 516.35,
    rx: 161.83,
    ry: 162.63
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#architecture_wide_svg__clip-path-3)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "architecture_wide_svg__cls-5",
    cx: 1274.02,
    cy: 523.96,
    rx: 161.61,
    ry: 161.63
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#architecture_wide_svg__clip-path-4)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "architecture_wide_svg__cls-2",
    cx: 1087.89,
    cy: 487.68,
    rx: 225.24,
    ry: 226.36
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "architecture_wide_svg__cls-2",
    cx: 1211.37,
    cy: 669.93,
    rx: 225.24,
    ry: 226.36
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "architecture_wide_svg__cls-2",
    cx: 1356.06,
    cy: 692.23,
    rx: 225.24,
    ry: 226.36
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "architecture_wide_svg__cls-2",
    cx: 1329.05,
    cy: 386.86,
    rx: 225.24,
    ry: 226.36
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "architecture_wide_svg__cls-2",
    cx: 1265.87,
    cy: 514.34,
    rx: 161.58,
    ry: 162.38
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "architecture_wide_svg__cls-2",
    cx: 1265.87,
    cy: 514.34,
    rx: 161.58,
    ry: 162.38
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "architecture_wide_svg__cls-11",
    cx: 1313.14,
    cy: 468.78,
    rx: 13.99,
    ry: 14.06
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "architecture_wide_svg__cls-11",
    cx: 1178.09,
    cy: 554.09,
    rx: 13.99,
    ry: 14.06
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "architecture_wide_svg__cls-11",
    cx: 1277.44,
    cy: 607.4,
    rx: 13.99,
    ry: 14.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-2",
    d: "M1379.95 364.37l34.73-34.88m-3.95 31.57l5.77-32.92-32.47 5.9m-4.08 330.27l34.73 34.88m-3.95-31.57l5.77 32.92-32.47-5.9m-232.24-330.27l-34.74-34.88m3.96 31.57l-5.77-32.92 32.47 5.9m4.08 330.27l-34.74 34.88m3.96-31.57l-5.77 32.92 32.47-5.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-13",
    d: "M2699.64 828.05h132.54v52.85h-132.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-11",
    d: "M2714.06 840.11h103.7v28.72h-103.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-2",
    d: "M2712.7 828.09v-18.65m26.6 18.65v-18.65m26.61 18.65v-18.65m26.61 18.65v-18.65m26.61 18.65v-18.65M2712.7 899.5v-18.65m26.6 18.65v-18.65m26.61 18.65v-18.65m26.61 18.65v-18.65m26.61 18.65v-18.65m-52.85-141.23l.13 44.3m-17.58-22.62l17.29 24.63 16.88-24.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-13",
    d: "M2735.6 717.87l60.73-.12a28.9 28.9 0 0028.72-28.83 28.9 28.9 0 00-28.83-28.72l-60.73.12a28.9 28.9 0 00-28.72 28.83 28.9 28.9 0 0028.83 28.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-11",
    d: "M2794.17 674.18a14.93 14.93 0 11-14.9 15 14.91 14.91 0 0114.9-15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-13",
    d: "M2796.22 583.12l-60.73.12a28.9 28.9 0 00-28.72 28.83 28.9 28.9 0 0028.83 28.72l60.73-.12a28.9 28.9 0 0028.72-28.83 28.9 28.9 0 00-28.83-28.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-11",
    d: "M2737.65 626.81a14.93 14.93 0 1114.9-15 14.91 14.91 0 01-14.9 15z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "architecture_wide_svg__cls-13",
    cx: 2903.46,
    cy: 761.77,
    rx: 68.31,
    ry: 68.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-2",
    d: "M2884.54 749.74l-13.7 11.62-5.8-17.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-2",
    d: "M2881.52 787.66a33.34 33.34 0 0024 10.23c18.74 0 33.93-15.64 33.93-34.94s-15.2-34.95-33.94-34.95c-16.61 0-30.44 12.29-33.36 28.53m-562.68-96.74h-166.94a19.1 19.1 0 01-19-19.45v-38.91a19.19 19.19 0 0119.41-19.43h330.39a19.19 19.19 0 0119.43 19.45v21.26"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "architecture_wide_svg__cls-11",
    cx: 2173.2,
    cy: 621.12,
    rx: 13.09,
    ry: 13.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "architecture_wide_svg__cls-11",
    cx: 2225.54,
    cy: 621.12,
    rx: 13.09,
    ry: 13.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "architecture_wide_svg__cls-11",
    cx: 2277.88,
    cy: 621.12,
    rx: 13.09,
    ry: 13.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-2",
    d: "M2309.88 765.25h-166.94a19.19 19.19 0 01-19.43-19.45v-38.91a19.19 19.19 0 0119.43-19.45h166.94"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "architecture_wide_svg__cls-11",
    cx: 2173.2,
    cy: 726.29,
    rx: 13.09,
    ry: 13.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "architecture_wide_svg__cls-11",
    cx: 2225.54,
    cy: 726.29,
    rx: 13.09,
    ry: 13.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "architecture_wide_svg__cls-11",
    cx: 2277.88,
    cy: 726.29,
    rx: 13.09,
    ry: 13.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-2",
    d: "M2449.72 869.65h-306.78a19.19 19.19 0 01-19.43-19.45v-38.91a19.19 19.19 0 0119.43-19.45h166.94"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "architecture_wide_svg__cls-11",
    cx: 2173.2,
    cy: 830.51,
    rx: 13.09,
    ry: 13.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "architecture_wide_svg__cls-11",
    cx: 2225.54,
    cy: 830.51,
    rx: 13.09,
    ry: 13.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "architecture_wide_svg__cls-11",
    cx: 2277.88,
    cy: 830.51,
    rx: 13.09,
    ry: 13.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-2",
    d: "M2311.14 819.23h166.67M2323 622.69a12.34 12.34 0 00-12.49 12.5v205.54a12.34 12.34 0 0012.49 12.5m126.72.04v48.36m23.24-82.4h166.67"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#architecture_wide_svg__clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-5",
    d: "M2639.16 863.58a12.34 12.34 0 0012.49-12.5V646.8c0-7-5.46-13.76-12.49-13.76h-304.78c-7 0-12.49 6.72-12.49 13.76v204.28a12.34 12.34 0 0012.49 12.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-2",
    d: "M2627.77 853.23a12.34 12.34 0 0012.49-12.5V636.45c0-7-5.46-13.76-12.49-13.76H2323c-7 0-12.49 6.72-12.49 13.76v204.28a12.34 12.34 0 0012.49 12.5zm-126.72.04v48.36m43.32 2.95H2406.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-11",
    d: "M2472.78 832.63a4.72 4.72 0 00-1.24 3.32 4.13 4.13 0 001.45 3.32 4.7 4.7 0 006.64-6.64 5.32 5.32 0 00-6.85 0z",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-11",
    d: "M239.48 551.44a42.19 42.19 0 1142.11-42.27 42.15 42.15 0 01-42.11 42.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-2",
    d: "M364.23 448l-129.38.25a61.56 61.56 0 00-61.18 61.41 61.56 61.56 0 0061.42 61.18l129.38-.25a61.56 61.56 0 0061.18-61.41A61.56 61.56 0 00364.23 448zM262.84 692.19a185.46 185.46 0 014.48-367.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-20",
    d: "M263.79 341.7l26.93-18.29-29.31-14.18 2.38 32.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-2",
    d: "M321.58 326a185.46 185.46 0 01-7.47 366.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-20",
    d: "M317.65 675.98l-26.93 18.3 29.31 14.18-2.38-32.48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-21",
    d: "M524.77 514.17l7.85-5.07-7.53-5.54.21-.28 7.95 5.84-8.29 5.35-.19-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.16,
    opacity: 0.24,
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M548.66 514.66l8.27-5.39-7.99-5.81.22-.31 8.43 6.14-8.73 5.69-.2-.32z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.31,
    opacity: 0.28,
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M572.55 515.16l8.69-5.72-8.44-6.09.23-.32 8.91 6.43-9.17 6.03-.22-.33z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.47,
    opacity: 0.31,
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M596.44 515.66l9.11-6.05-8.89-6.36.24-.34 9.38 6.72-9.61 6.38-.23-.35z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.62,
    opacity: 0.35,
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M620.33 516.16l9.53-6.38-9.35-6.64.25-.35 9.87 7.01-10.06 6.72-.24-.36z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.78,
    opacity: 0.39,
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M644.22 516.66l9.95-6.7-9.8-6.92.26-.38 10.35 7.3-10.51 7.08-.25-.38z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.93,
    opacity: 0.43,
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M668.11 517.16l10.38-7.03-10.27-7.2.28-.39 10.83 7.59-10.95 7.42-.27-.39z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.09,
    opacity: 0.47,
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M692 517.66l10.8-7.36-10.72-7.47.28-.41 11.31 7.88-11.39 7.77-.28-.41z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.24,
    opacity: 0.5,
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M715.89 518.15l11.22-7.68-11.18-7.75.3-.42 11.79 8.17-11.84 8.11-.29-.43z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.4,
    opacity: 0.54,
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M739.78 518.65l11.64-8.01-11.63-8.03.3-.44 12.28 8.47-12.29 8.46-.3-.45z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.55,
    opacity: 0.58,
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M763.68 519.15l12.06-8.34-12.08-8.3.31-.46 12.75 8.76-12.72 8.8-.32-.46z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.71,
    opacity: 0.62,
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M787.59 519.65l12.48-8.66-12.54-8.59.33-.47 13.23 9.05-13.17 9.15-.33-.48z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.87,
    opacity: 0.66,
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M811.49 520.15l12.91-8.99-13-8.86.34-.5 13.71 9.35-13.61 9.49-.35-.49z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2.02,
    opacity: 0.7,
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M835.4 520.65l13.33-9.32-13.46-9.14.35-.51 14.19 9.64-14.05 9.83-.36-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2.18,
    opacity: 0.73,
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M859.31 521.14l13.74-9.64-13.9-9.41.36-.53 14.67 9.93-14.51 10.18-.36-.53z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2.33,
    opacity: 0.77,
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M883.22 521.64l14.16-9.97-14.36-9.69.37-.55 15.15 10.23-14.94 10.52-.38-.54z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2.49,
    opacity: 0.81,
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M907.12 522.14l14.59-10.3-14.82-9.96.38-.57 15.64 10.52-15.4 10.87-.39-.56z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2.64,
    opacity: 0.85,
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M931.03 522.64l15.01-10.63-15.27-10.24.39-.58L947.27 512l-15.84 11.21-.4-.57z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2.8,
    opacity: 0.89,
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M954.94 523.14l15.43-10.96-15.73-10.52.4-.6 16.59 11.11-16.28 11.56-.41-.59z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2.95,
    opacity: 0.92,
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M978.85 523.64l15.85-11.28-16.19-10.8.41-.62 17.08 11.4-16.73 11.9-.42-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 3.11,
    opacity: 0.96,
    fill: "#0e1932",
    stroke: "#0e1932",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1002.75 524.14l16.27-11.61-16.64-11.08.43-.63 17.55 11.69-17.17 12.24-.44-.61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-2",
    d: "M1026.66 524.63l16.69-11.93-17.09-11.35.43-.65 18.03 11.98-17.61 12.59-.45-.64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-21",
    d: "M1481.19 513.97l8.75-3.29-6.18-7 .26-.24 6.53 7.39-9.23 3.47-.13-.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-42",
    d: "M1504.14 519.45l9.16-3.48-6.51-7.31.28-.25 6.86 7.72-9.65 3.67-.14-.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-43",
    d: "M1527.1 524.93l9.55-3.67-6.83-7.62.29-.26 7.21 8.04-10.08 3.88-.14-.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-44",
    d: "M1550.05 530.41l9.96-3.86-7.16-7.93.3-.27 7.55 8.37-10.5 4.07-.15-.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-45",
    d: "M1573 535.9l10.37-4.06-7.49-8.24.32-.29 7.89 8.7-10.93 4.28-.16-.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-46",
    d: "M1595.96 541.38l10.76-4.25-7.8-8.55.32-.3 8.24 9.02-11.36 4.49-.16-.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-47",
    d: "M1618.91 546.86l11.17-4.44-8.13-8.86.34-.31 8.58 9.35-11.79 4.69-.17-.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-48",
    d: "M1641.86 552.34l11.58-4.63-8.46-9.17.35-.32 8.92 9.67-12.21 4.89-.18-.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-49",
    d: "M1664.81 557.83l11.98-4.84-8.77-9.47.36-.34 9.26 10-12.64 5.1-.19-.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-50",
    d: "M1687.77 563.31l12.38-5.03-9.1-9.78.37-.35 9.6 10.33-13.06 5.3-.19-.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-51",
    d: "M1710.72 568.79l12.79-5.22-9.43-10.09.38-.36 9.95 10.65-13.49 5.51-.2-.49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-52",
    d: "M1733.67 574.27l13.19-5.41-9.75-10.4.4-.37 10.29 10.97-13.92 5.71-.21-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-53",
    d: "M1756.63 579.75l13.59-5.6-10.08-10.71.41-.39 10.63 11.31-14.34 5.91-.21-.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-54",
    d: "M1779.58 585.24l14-5.8-10.4-11.02.42-.4 10.97 11.63-14.77 6.12-.22-.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-55",
    d: "M1802.53 590.72l14.4-5.99-10.72-11.33.43-.41 11.32 11.95-15.2 6.33-.23-.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-56",
    d: "M1825.48 596.2l14.81-6.18-11.05-11.64.44-.42 11.66 12.28-15.62 6.52-.24-.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-57",
    d: "M1848.44 601.68l15.21-6.38-11.38-11.94.46-.43 12 12.6-16.05 6.73-.24-.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-58",
    d: "M1871.39 607.16l15.62-6.57-11.7-12.25.46-.45 12.35 12.94-16.48 6.93-.25-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-59",
    d: "M1894.34 612.65l16.02-6.77-12.02-12.56.48-.46 12.68 13.26-16.9 7.14-.26-.61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-60",
    d: "M1917.3 618.13l16.42-6.96-12.35-12.87.49-.47 13.03 13.58-17.33 7.34-.26-.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-61",
    d: "M1940.25 623.61l16.83-7.15-12.68-13.18.5-.48 13.38 13.91-17.76 7.54-.27-.64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-62",
    d: "M1963.2 629.09l17.23-7.34-12.99-13.49.51-.5 13.71 14.24-18.18 7.75-.28-.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-63",
    d: "M1986.15 634.58l17.64-7.54-13.32-13.8.52-.51 14.06 14.56-18.61 7.96-.29-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-64",
    d: "M2009.11 640.06l18.04-7.73-13.65-14.11.54-.52 14.39 14.89-19.03 8.15-.29-.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-65",
    d: "M2032.06 645.54l18.44-7.92-13.97-14.42.55-.53 14.74 15.21-19.46 8.36-.3-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-2",
    d: "M2055.01 651.02l18.85-8.12-14.29-14.72.56-.54 15.08 15.53-19.89 8.57-.31-.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-21",
    d: "M1480.63 501.84l8.78 3.21-6.13 7.06.27.23 6.46-7.45-9.26-3.39-.12.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-42",
    d: "M1503.6 496.14l9.19 3.4-6.45 7.37.28.24 6.8-7.77-9.69-3.59-.13.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-43",
    d: "M1526.58 490.44l9.58 3.59-6.76 7.68.29.26 7.14-8.11-10.12-3.79-.13.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-44",
    d: "M1549.55 484.74l9.99 3.78-7.08 7.99.3.27 7.48-8.43-10.55-3.99-.14.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-45",
    d: "M1572.53 479.04l10.39 3.97-7.4 8.31.31.28 7.82-8.77-10.97-4.18-.15.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-46",
    d: "M1595.5 473.34l10.8 4.16-7.73 8.62.33.29 8.16-9.09-11.4-4.39-.16.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-47",
    d: "M1618.47 467.64l11.21 4.35-8.05 8.93.34.31 8.5-9.42-11.83-4.59-.17.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-48",
    d: "M1641.45 461.94l11.61 4.54-8.37 9.24.35.32 8.84-9.75-12.26-4.79-.17.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-49",
    d: "M1664.42 456.25l12.02 4.72-8.69 9.55.36.34 9.18-10.08-12.69-4.99-.18.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-50",
    d: "M1687.4 450.55l12.42 4.91-9.02 9.87.38.34 9.51-10.41-13.11-5.19-.18.48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-51",
    d: "M1710.37 444.85l12.83 5.1-9.34 10.18.39.36 9.85-10.74-13.54-5.39-.19.49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-52",
    d: "M1733.34 439.15l13.24 5.29-9.66 10.49.4.37 10.19-11.07-13.96-5.59-.21.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-53",
    d: "M1756.32 433.45l13.64 5.49-9.98 10.79.41.38 10.53-11.39-14.39-5.79-.21.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-54",
    d: "M1779.29 427.75l14.05 5.68-10.3 11.11.42.39 10.87-11.73-14.82-5.99-.22.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-55",
    d: "M1802.27 422.05l14.45 5.87-10.63 11.42.44.4 11.21-12.05-15.25-6.19-.22.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-56",
    d: "M1825.24 416.35l14.86 6.06-10.95 11.73.45.42 11.55-12.38-15.68-6.39-.23.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-57",
    d: "M1848.21 410.65l15.27 6.25-11.27 12.04.46.43 11.89-12.71-16.11-6.59-.24.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-58",
    d: "M1871.19 404.95l15.67 6.44-11.59 12.35.47.45 12.23-13.04-16.54-6.79-.24.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-59",
    d: "M1894.16 399.25l16.08 6.63-11.91 12.67.48.45 12.57-13.37-16.97-6.99-.25.61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-60",
    d: "M1917.14 393.56l16.48 6.81-12.24 12.98.5.46 12.91-13.69-17.4-7.19-.25.63z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-61",
    d: "M1940.11 387.86l16.89 7-12.56 13.29.51.48 13.24-14.02-17.81-7.4-.27.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-62",
    d: "M1963.08 382.16l17.3 7.19-12.88 13.6.52.49 13.58-14.35-18.24-7.59-.28.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-63",
    d: "M1986.06 376.46l17.7 7.38-13.2 13.92.53.5 13.92-14.68-18.67-7.79-.28.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-64",
    d: "M2009.03 370.76l18.11 7.57-13.52 14.23.54.51 14.26-15.01-19.1-7.99-.29.69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-65",
    d: "M2032.01 365.06l18.51 7.76-13.85 14.54.55.53 14.61-15.34-19.53-8.19-.29.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "architecture_wide_svg__cls-2",
    d: "M2054.98 359.36l18.91 7.95-14.16 14.85.57.54 14.94-15.67-19.96-8.39-.3.72z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "architecture_wide_svg__cls-2",
    cx: 517.32,
    cy: 509.96,
    r: 8.96
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1482.32,
    cy: 509.96,
    r: 8.96,
    fill: "#e5eff3",
    strokeWidth: 3.27,
    stroke: "#0e1932",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

export default __webpack_public_path__ + "static/architecture_wide.c2454781.svg";
export { SvgArchitectureWide as ReactComponent };